import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GuardsService } from './core/guards/guards.service';


const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./features/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'adm',
    loadChildren: () => import('./features/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule),
    canActivate: [GuardsService]
  },
  {
    path: 'manager-inicio',
    loadChildren: () => import('./features/manager/manager-inicio/manager-inicio.module').then(m => m.ManagerInicioModule),
    canActivate: [GuardsService]
  },
  {
    path: 'manager-lista',
    loadChildren: () => import('./features/manager/manager-items/manager-items.module').then(m => m.ManagerItemsModule),
    canActivate: [GuardsService]
  },
  {
    path: 'manager-user-info',
    loadChildren: () => import('./features/manager/manager-user-info/manager-user-info.module').then(m => m.ManagerUserInfoComponentModule),
    canActivate: [GuardsService]
  },
  {
    path: 'view-items',
    loadChildren: () => import('./features/manager/manager-inicio/manager-view-items/manager-view-items.module').then(m => m.ManagerViewItemsModule),
    canActivate: [GuardsService]
  },
  {
    path: 'people-entered',
    loadChildren: () => import('./features/manager/manager-inicio/people-entered/people-entered.module').then(m => m.PeopleEnteredModule),
    canActivate: [GuardsService]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
